import React from 'react'
import { IdentificationStepsContextProvider } from '../../context/Identification'
import { IdentificationStepRoutes } from '../../routes/identification/identificationRoutes'

export default function IdentificationWithStepsContext() {
  return (
    <IdentificationStepsContextProvider>
      <IdentificationStepRoutes />
    </IdentificationStepsContextProvider>
  )
}
